import React from 'react';
import './Products.css';
import Carousel from './Carousel';
import facerecoImg from './resources/facereco.png';
import codexferImg from './resources/codexfer.png';
import openbridgeaiImg from './resources/openbridgeai.png';
import pixelflowImg from './resources/pixelflow.png';

const productsData = [
  {
    id: 1,
    title: 'Facereco',
    description: 'Advanced AI-powered face recognition and management system. Features real-time matching, secure database integration, and intuitive analytics.',
    link: 'https://facereco.kshitijks.com/',
    tech: ['React', 'Firebase', 'AI/ML'],
    image: facerecoImg,
    status: 'Live'
  },
  {
    id: 2,
    title: 'CodeXfer',
    description: 'Secure, lightning-fast peer-to-peer file transfer platform using WebRTC. Direct browser-to-browser encrypted transfers with no server storage.',
    link: 'https://codexfer.com/',
    tech: ['React', 'WebRTC', 'Firebase'],
    image: codexferImg,
    status: 'Live'
  },
  {
    id: 3,
    title: 'OpenBridgeAI',
    description: 'A full-stack AI platform featuring smart routing and automatic failover across multiple AI providers (Gemini, OpenAI, Anthropic).',
    link: 'https://openbridgeai.kshitijks.com/',
    tech: ['Next.js', 'AI Routing', 'Firestore'],
    image: openbridgeaiImg,
    status: 'Live'
  },
  {
    id: 4,
    title: 'PixelFlow',
    description: 'Autonomous AI video creation platform. Automatically generates scripts, acquires media, and renders videos on autopilot.',
    link: '#',
    tech: ['AI Pipelines', 'FFmpeg', 'Next.js'],
    image: pixelflowImg,
    status: 'Project Phase'
  }
];


export default function Products({ isVisible }) {
  const renderProductCard = (product) => (
    <div className="product-card">
      <div className="product-image-wrapper">
        <img src={product.image} alt={product.title} className="product-image" />
        <div className="product-overlay">
          <div className="product-status-badge">{product.status}</div>
        </div>
      </div>

      <div className="product-info">
        <h3 className="product-card-title">{product.title}</h3>
        <p className="product-card-description">{product.description}</p>

        <div className="product-tech-stack">
          {product.tech.map((tech, i) => (
            <span key={i} className="tech-tag">{tech}</span>
          ))}
        </div>

        <div className="product-actions">
          {product.link ? (
            <a
              href={product.link}
              target="_blank"
              rel="noopener noreferrer"
              className="product-btn primary"
              onClick={(e) => e.stopPropagation()}
            >
              Visit Product
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="7" y1="17" x2="17" y2="7"></line>
                <polyline points="7 7 17 7 17 17"></polyline>
              </svg>
            </a>
          ) : (
            <button className="product-btn disabled" disabled>
              Project Phase
            </button>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <Carousel
      items={productsData}
      renderCard={renderProductCard}
      isVisible={isVisible}
    />
  );
}
